import axios from 'utils/axios';

export const getNotificationsSettings = (channel: 'SMS' | 'EMAIL' | 'PUSH') => {
  return axios.get(`/api/v1/notifications/settings/${channel}`);
};
